export const navLinks = [
  { label: "历史记录", href: "#timeline" },
  { label: "往期合集", href: "#collections" },
  { label: "补课热榜", href: "#ranking" },
  { label: "讨论区", href: "#discussion" },
  { label: "归档索引", href: "#index" },
];

export const heroStats = [
  { value: "1,286", label: "归档条目" },
  { value: "94", label: "往期合集" },
  { value: "2019", label: "最早回溯" },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20collage%20with%20layered%20paper%20cutouts%20and%20grainy%20texture%2C%20warm%20cream%20and%20brick%20red%20palette%2C%20vintage%20archive%20folder%20aesthetic%2C%20soft%20natural%20light%2C%20muted%20noir%20mood%2C%20no%20text%2C%20high%20detail&width=800&height=1000&seq=hl-hero-cover-01&orientation=portrait";

export const yearFilters = ["全部年份", "2026", "2025", "2024", "2023", "2022", "更早"];
export const typeFilters = ["全部类型", "人物线", "事件线", "回应合集", "时间线复盘"];

export const timelineEntries = [
  {
    id: "t1",
    date: "2026-08-28",
    tag: "事件线",
    title: "夏之然合约风波：从传闻到正式声明的时间线整理",
    summary:
      "前后共 7 个节点，从最早的路透照片到工作室一句式回应，按日期排好，主要分歧点都标出来了。",
    readTime: "12 分钟",
    comments: 486,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20a%20contract%20document%20silhouette%20with%20geometric%20shapes%2C%20warm%20cream%20and%20brick%20red%20palette%2C%20grainy%20paper%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=hl-tl-01&orientation=landscape",
  },
  {
    id: "t2",
    date: "2026-07-15",
    tag: "回应合集",
    title: "小苏直播失言事件：三方回应原文与时间顺序",
    summary:
      "当事人、品牌方、平台侧三份回应按发布先后排列，附带对比表格，方便看清前后口径变化。",
    readTime: "9 分钟",
    comments: 372,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20speech%20bubbles%20and%20geometric%20blocks%2C%20warm%20cream%20and%20clay%20taupe%20palette%2C%20grainy%20paper%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=hl-tl-02&orientation=landscape",
  },
  {
    id: "t3",
    date: "2026-05-30",
    tag: "人物线",
    title: "选秀歌手 L 的家事争议：能确认的和不能确认的",
    summary:
      "把可查证的公开信息与未经证实的传闻分开列，先给结论再补细节，回看时不容易被带偏。",
    readTime: "15 分钟",
    comments: 615,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20split%20paper%20sheets%20and%20thin%20lines%2C%20warm%20ivory%20and%20amber%20palette%2C%20grainy%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=hl-tl-03&orientation=landscape",
  },
  {
    id: "t4",
    date: "2026-03-12",
    tag: "时间线复盘",
    title: "网红 Kiwi 带货翻车复盘：48 小时内的关键节点",
    summary:
      "以小时为单位还原从第一条质疑到平台介入的完整过程，附上当时的截图描述与后续处理结果。",
    readTime: "11 分钟",
    comments: 298,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20clock%20face%20fragments%20and%20grid%20lines%2C%20warm%20cream%20and%20brick%20red%20palette%2C%20grainy%20paper%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=hl-tl-04&orientation=landscape",
  },
  {
    id: "t5",
    date: "2025-11-04",
    tag: "事件线",
    title: "乐队巡演退票争议：一整个月的来龙去脉",
    summary:
      "从公告到退票到最终补偿方案，按周拆分，每个阶段的关键文件都做了索引与摘要。",
    readTime: "13 分钟",
    comments: 421,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20ticket%20stubs%20and%20stage%20light%20shapes%2C%20warm%20amber%20and%20clay%20palette%2C%20grainy%20paper%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=hl-tl-05&orientation=landscape",
  },
  {
    id: "t6",
    date: "2025-06-19",
    tag: "人物线",
    title: "演员程屿旧访谈被翻出：一句话引发的连锁讨论",
    summary:
      "把旧访谈原段落、当时的上下文和后来各方的解读放在一起，回看时信息更完整。",
    readTime: "8 分钟",
    comments: 233,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20open%20book%20pages%20and%20rounded%20shapes%2C%20warm%20ivory%20and%20muted%20red%20palette%2C%20grainy%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=hl-tl-06&orientation=landscape",
  },
];

export const collections = [
  {
    id: "c1",
    title: "2026 上半年 · 事件合集打包",
    period: "2026.01 - 2026.06",
    count: 24,
    desc: "半年内 24 条主要事件按时间顺序打包，附关系人物索引，适合一次性补完。",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20vintage%20archive%20folders%20with%20paper%20labels%2C%20warm%20cream%20and%20brick%20red%20palette%2C%20grainy%20editorial%20texture%2C%20soft%20natural%20light%2C%20no%20text%2C%20high%20detail&width=640&height=440&seq=hl-col-01&orientation=landscape",
  },
  {
    id: "c2",
    title: "回应声明专题合集",
    period: "2023 - 2026",
    count: 37,
    desc: "把历年各方回应声明单独归档，按发布时间排列，比对口径变化最方便。",
    image:
      "https://readdy.ai/api/search-image?query=Overlapping%20paper%20documents%20with%20seals%20abstractly%20arranged%2C%20warm%20ivory%20and%20amber%20palette%2C%20grainy%20editorial%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=640&height=440&seq=hl-col-02&orientation=landscape",
  },
  {
    id: "c3",
    title: "选秀出身艺人 · 人物长线",
    period: "2019 - 2026",
    count: 18,
    desc: "围绕同一批选秀艺人整理的长期记录，按人物拆分，线索不会断在中间。",
    image:
      "https://readdy.ai/api/search-image?query=Timeline%20thread%20with%20small%20photo%20frames%20abstract%20collage%2C%20warm%20cream%20and%20clay%20taupe%20palette%2C%20grainy%20editorial%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=640&height=440&seq=hl-col-03&orientation=landscape",
  },
  {
    id: "c4",
    title: "旧瓜补课 · 早年整理",
    period: "2019 - 2021",
    count: 15,
    desc: "最早一批归档内容，很多线索零散，这里已经按事件重新拼好，方便慢慢回看。",
    image:
      "https://readdy.ai/api/search-image?query=Old%20cardboard%20box%20of%20letters%20and%20press%20clippings%20abstract%20collage%2C%20warm%20sepia%20and%20muted%20red%20palette%2C%20grainy%20editorial%20texture%2C%20soft%20light%2C%20no%20text%2C%20high%20detail&width=640&height=440&seq=hl-col-04&orientation=landscape",
  },
];

export const ranking = [
  { rank: 1, title: "夏之然合约风波完整时间线", tag: "事件线", heat: "9.8万", trend: "up" },
  { rank: 2, title: "小苏直播失言三方回应合集", tag: "回应合集", heat: "7.4万", trend: "up" },
  { rank: 3, title: "选秀歌手 L 家事争议梳理", tag: "人物线", heat: "6.9万", trend: "flat" },
  { rank: 4, title: "Kiwi 带货翻车 48 小时复盘", tag: "时间线复盘", heat: "5.1万", trend: "down" },
  { rank: 5, title: "乐队巡演退票争议全记录", tag: "事件线", heat: "4.6万", trend: "up" },
  { rank: 6, title: "演员程屿旧访谈被翻出", tag: "人物线", heat: "3.2万", trend: "flat" },
];

export const discussions = [
  {
    id: "d1",
    user: "翻旧档的人",
    time: "12 分钟前",
    text: "上半年那份合集整理得挺细，连当时被删掉的表述都标注了，补课省了不少事。",
    likes: 128,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20avatar%20shape%20on%20warm%20cream%20background%2C%20brick%20red%20and%20clay%20tones%2C%20grainy%20texture%2C%20flat%20editorial%20style%2C%20no%20text&width=200&height=200&seq=hl-av-01&orientation=squarish",
  },
  {
    id: "d2",
    user: "只看时间线",
    time: "1 小时前",
    text: "建议把回应声明再按人物拆一层，现在找某个人的口径要翻半天，不过整体已经很好用了。",
    likes: 76,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20avatar%20shape%20on%20warm%20ivory%20background%2C%20amber%20and%20clay%20tones%2C%20grainy%20texture%2C%20flat%20editorial%20style%2C%20no%20text&width=200&height=200&seq=hl-av-02&orientation=squarish",
  },
  {
    id: "d3",
    user: "慢慢看的老网友",
    time: "3 小时前",
    text: "早年那条实在是零散，这里能拼出一条完整线出来，属于是帮我补了个大课。",
    likes: 214,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20avatar%20shape%20on%20warm%20sand%20background%2C%20muted%20red%20and%20taupe%20tones%2C%20grainy%20texture%2C%20flat%20editorial%20style%2C%20no%20text&width=200&height=200&seq=hl-av-03&orientation=squarish",
  },
];

export const discussionCount = "2,041";

export const monthIndex = [
  { year: "2026", months: ["01", "02", "03", "04", "05", "06", "07", "08"] },
  { year: "2025", months: ["03", "04", "06", "08", "09", "11", "12"] },
  { year: "2024", months: ["02", "05", "07", "10"] },
  { year: "2023", months: ["01", "04", "09"] },
  { year: "2022", months: ["06", "08"] },
  { year: "2019-2021", months: ["2019", "2020", "2021"] },
];

export const faqs = [
  {
    q: "黑料在线历史记录是怎么排的？",
    a: "首页的归档时间线按发布时间从新到旧排列，每个条目都标注了日期和类型标签，点开合集可以往下继续翻更早的记录。",
  },
  {
    q: "往期合集和单条记录有什么区别？",
    a: "单条记录针对一件具体事件，往期合集则是把同一时期或同一主题的多条记录打包在一起，适合一次性补完一整段时间。",
  },
  {
    q: "旧瓜复盘里的信息都可靠吗？",
    a: "归档时会把可查证的公开信息与未经证实的传闻分开标注，回看时请以标注为准，不要直接当成结论。",
  },
  {
    q: "可以只补某个人的线索吗？",
    a: "可以。人物线把同一个人的相关记录串在一起，配合顶部检索工具条按名字或关键词筛选，会比按时间翻更快。",
  },
];

export const footerColumns = [
  {
    title: "浏览",
    links: ["历史记录", "往期合集", "补课热榜", "归档索引"],
  },
  {
    title: "归档说明",
    links: ["信息标注规则", "时间线口径", "更正与补充", "联系归档组"],
  },
];